import { render, staticRenderFns } from "./Versamento.vue?vue&type=template&id=86db8332&scoped=true&"
import script from "./Versamento.vue?vue&type=script&lang=js&"
export * from "./Versamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86db8332",
  null
  
)

export default component.exports